<template>
    <div>
        <filtro-cadu
            v-model="valueData"
            :items="items"
            @limparFiltro="limparFiltro()"
            @filtrar="filtrarMedidaInterventiva()"
            @input="value => closeFilter(value)"
        >
            <div slot="body" style="height: 420px">
                <v-row class="mx-2">
                    <v-col cols="auto">
                        <div class="fontColor1--text">
                            FILTRAR MEDIDAS INTERVENTIVAS
                        </div>
                    </v-col>
                </v-row>
                <ValidationObserver ref="observer" v-slot="{ slot: passes }">
                    <v-row class="mx-2">
                        <v-col cols="12">
                            <validation-provider name="tipoIntervencao" mode="eager" rules="alpha_spaces|max:40" v-slot="{ errors }">
                                <autocomplete-cadu
                                    :items="listaTipoIntervencao.map(el => el.nome)"
                                    :errorMessage="errors[0]"
                                    title="Tipo de Intervenção"
                                    v-model="tipoIntervencao"
                                />
                            </validation-provider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="auto" class="mx-5">
                            <div class="fontColor1--text">
                                VIGÊNCIA
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5" no-gutters>
                        <v-col cols="4">
                            <checkbox-cadu v-model="checkAll" obligatory single value="VIGENTE" rounded>
                                <div slot="text">
                                    Vigente
                                </div>
                            </checkbox-cadu>
                        </v-col>
                        <v-col cols="5">
                            <checkbox-cadu v-model="checkAll" obligatory single value="NAO_VIGENTE" rounded>
                                <div slot="text">
                                    Não Vigente
                                </div>
                            </checkbox-cadu>
                        </v-col>
                        <v-col cols="3">
                            <checkbox-cadu v-model="checkAll" obligatory single value="TODOS" rounded>
                                <div slot="text">
                                    Todos
                                </div>
                            </checkbox-cadu>
                        </v-col>
                    </v-row>
                </ValidationObserver>
            </div>
        </filtro-cadu>
    </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import TipoIntervencao from '@/services/Dominios/TipoIntervencao'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    items: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
      valueData: this.value,
      listaTipoIntervencao: [],
      tipoIntervencao: '',
      checkAll: ['TODOS'],
      vigenciaSelecionada: '',
      role: ''
    }
  },
  async beforeMount () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.getTipoIntervencao()
  },
  methods: {
    async getTipoIntervencao () {
      let tipoIntervencao = new TipoIntervencao(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseTipoIntervencao = await tipoIntervencao.getTipoIntervencao()
        this.listaTipoIntervencao = responseTipoIntervencao.data
      } catch (err) {
        this.listaIntervencao = []
      }
    },
    limparFiltro () {
      this.tipoIntervencao = ''
      this.checkAll = ['TODOS']
    },
    filtrarMedidaInterventiva () {
      let filtro = {
        tipoIntervencao: (this.listaTipoIntervencao.find(item => item.nome === this.tipoIntervencao) != null) ? this.listaTipoIntervencao.find(item => item.nome === this.tipoIntervencao) : null,
        vigencia: this.checkAll
      }
      this.$emit('filtrar-medida-interventiva', filtro)
    },
    closeFilter (value) {
      if (!value) {
        this.$emit('close')
      }
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    }
  }
}
</script>

<style scoped>

</style>
